import React from 'react';

import './PlanTopupCallout.css';

/** A plan's top-up rate and its discount against the Free plan's rate; null when the plan has no top-ups. */
export type TopupOffer = { rate: string; baseRate: string; discount: number } | null;

/**
 * The top-up callout on a plan card (billing dialog and pricing page): "69% off
 * top-ups" in red over the plan's rate, with the Free rate struck through.
 */
export const PlanTopupCallout: React.FC<{
  topup: TopupOffer;
  /** What to say instead of a rate; by default the plan needs no top-ups (Unlimited). */
  fallback?: { headline: string; note: string };
}> = ({ topup, fallback = { headline: 'No top-ups needed', note: 'Usage is never deducted' } }) => {
  if (!topup) {
    return (
      <div className="upgrade-plan-topup">
        <strong className="upgrade-plan-topup__headline">{fallback.headline}</strong>
        <span className="upgrade-plan-topup__rates">{fallback.note}</span>
      </div>
    );
  }
  const discounted = topup.discount > 0;

  return (
    <div className={`upgrade-plan-topup${discounted ? ' upgrade-plan-topup--discount' : ''}`}>
      <span className="upgrade-plan-topup__headline">
        {discounted && <strong className="upgrade-plan-topup__save">{topup.discount}% off</strong>}
        <span className="upgrade-plan-topup__label">{discounted ? 'top-ups' : 'Top-ups'}</span>
      </span>
      <span className="upgrade-plan-topup__rates">
        {discounted && <s className="upgrade-plan-topup__base" title="The Free plan's top-up rate">{topup.baseRate}</s>}
        <span className="upgrade-plan-topup__rate">{topup.rate}</span>
      </span>
    </div>
  );
};
